export const categories = [
  {
    slug: 'latest-news',
    name: '最新动态',
    description: '三上悠亚的最新资讯与活动报道',
    icon: 'ri-flashlight-line',
  },
  {
    slug: 'works',
    name: '作品全览',
    description: '影视作品、写真集与音乐作品',
    icon: 'ri-film-line',
  },
  {
    slug: 'photo-gallery',
    name: '写真图集',
    description: '精美写真与杂志拍摄花絮',
    icon: 'ri-camera-line',
  },
  {
    slug: 'interviews',
    name: '专访报道',
    description: '独家访谈与幕后故事',
    icon: 'ri-mic-line',
  },
  {
    slug: 'fan-corner',
    name: '粉丝天地',
    description: '粉丝活动、应援与互动内容',
    icon: 'ri-heart-line',
  },
  {
    slug: 'biography',
    name: '个人资料',
    description: '三上悠亚的成长历程与个人档案',
    icon: 'ri-user-star-line',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});